import {CloudName, CloudType, Environment} from '@q9elements/ui-kit/common';

export const environment: Environment = {
    production: true,
    CLOUD_TYPE: CloudType.PUBLIC,
    CLOUD_NAME: CloudName.ELEMENTS, 
    ENV: 'staging',      
    version: require('../../package.json').version,
    MAIN_APP_URL: 'https://staging-app.elements-eng.cloud',
    API_STATIC_FILE_UPLOAD: 'https://staging-upload.elements-eng.cloud:1443/api',
    CHANGELOG_APP_URL: 'https://staging-changelogs.elements-eng.cloud',
    API_ENDPOINT: 'https://staging-api.elements-eng.cloud/api/v1', 
    REMOTE_UNLOCK_TTL: 600000,
    TEAM_APP: 'https://staging-spacemgt.elements-eng.cloud',
    RELEASE_URL: 'https://staging-releasemgt.elements-eng.cloud',
    REPORTS_API_ENDPOINT: 'https://staging-gateway.elements-eng.cloud/report/api/v1',
    REF_MODEL_APP: 'https://staging-refmodel.elements-eng.cloud',
    REPORTS_APP: 'https://staging-report.elements-eng.cloud',
    MAP_MANAGEMENT_APP: 'https://staging-mapmgt.elements-eng.cloud',
    INTERCOM_APP_ID: 'sfi4u1en',
    DOMAIN: 'elements-eng.cloud',
    SECURE_COOKIES: true,
    SENTRY_AUTH_TOKEN: '',
    SENTRY_DSN: '',
    SENTRY_ORG: '',
    SENTRY_PROJECT: 'diagram-app',
    DIAGRAM_URL: 'https://staging-diagram.elements-eng.cloud',
    NOUI: false,
    DATA_STRUCTURE_URL: 'https://staging-datatable.elements-eng.cloud',
    SALESFORCE_CLIENT_ID: '3MVG9Rd3qC6oMalVszZtK2Usdv.BRF2ErH1PH2r2f2Aop_iJrJ0nCjq9blRIQKav.Aed1bBpVIVEZuMyw5VJC',
    STATIC_FILES_URL: 'https://static.elements-eng.cloud',
    JAM_TEAM_ID: '',
    MCP_OAUTH_URL: 'https://staging-api.elements-eng.cloud/api/v1/oauth',
    fbConfig: {
        apiKey:'AIzaSyCIrTPqlx_vQu_WFNfkg8IUIzoAL3Ij0gI',
        authDomain:'staging-elements.firebaseapp.com',
        databaseURL: 'https://staging-elements-default-rtdb.firebaseio.com',
        projectId: 'staging-elements',
        appId: '1:742374870043:web:8291e098ca434728fabcbe'
    }
};
